<template>
  <div>
    <div class="columns is-centered">
      <div class="column is-8 is-narrow">
        <br />
        <div>
          <div v-if="step == 0">
            <div class="box is-boxed-3" style="margin-bottom: 20px">
              <div class="has-text-centered">
                <p class="title has-text-dark">
                  Selamat Datang, {{ auth.name }}!
                </p>
                <hr />
                <success-check></success-check>
                <p>
                  Terima kasih telah mendaftar di
                  {{
                    !isEmpty(account) && !isEmpty(account.university.slug)
                      ? account.university.name
                      : "EdLink"
                  }},
                </p>
                <p>Ikuti langkah berikutnya untuk menikmati fitur yang ada.</p>
              </div>
            </div>

            <div class="columns">
              <div class="column has-text-right">
                <button
                  class="button is-primary4 is-medium"
                  @click.prevent="nextStep"
                >
                  <span>Berikutnya</span>
                  <span class="icon">→</span>
                </button>
              </div>
            </div>
          </div>

          <div v-else-if="step == 1">
            <div class="box is-boxed-2"
              style="margin-bottom: 20px; padding: 35px 28px 60px 28px; position: relative;">
              <p class="has-text-black font-20 font-w-600"
                style="padding-bottom: 42px">
                Privasi dan Kebijakan
              </p>
              <p class="has-text-black font-16">
                Untuk membuat Akun EdLink, Anda harus menyetujui Persyaratan
                Layanan. Selain itu, saat Anda membuat akun, kami memproses
                informasi seperti yang dijelaskan di <span class="has-text-primary" style="cursor: pointer;" @click.prevent="toPrivacyPolicy"> Kebijakan Privasi</span>.
                <span class="has-text-primary" style="cursor: pointer;" @click.prevent="toPrivacyPolicy"> Kebijakan Privasi</span> ini merupakan bagian dari Syarat dan Ketentuan
                Penggunaan.
              </p>
            </div>

            <div class="columns">
              <div class="column has-text-right">
                <button class="button is-primary4 is-medium"
                  @click.prevent="approvePrivacyPolicy">
                  <span>Saya Setuju</span>
                  <span class="icon">→</span>
                </button>
              </div>
            </div>
          </div>

          <div v-if="step == 2">
            <div class="columns is-centered">
              <div v-if="setupAccount === true" class="column">
                <add-university-account
                  :afterSave="nextStep"
                  :wizard="true"
                ></add-university-account>
              </div>
              <div v-else class="column is-9">
                <div class="box is-boxed-3" style="margin-bottom: 10px">
                  <p>
                    <i class="fas fa-check-circle has-text-primary"></i
                    >&nbsp;&nbsp;Berhasil tersambung dengan akun kampus
                    <strong>{{ auth.activeAccount.university.name }}</strong>
                  </p>
                  <br />
                  <div class="columns">
                    <div class="column">
                      <p class="title is-5 has-text-dark">
                        {{ auth.activeAccount.name }}
                      </p>
                      <p
                        class="subtitle is-6 has-text-grey"
                        style="margin-bottom: 5px"
                      >
                        {{ auth.activeAccount.userUniversityId }}
                      </p>
                      <p class="subtitle is-6 has-text-dark">
                        <span v-if="auth.activeAccount.type === 'ADMIN'"
                          >Admin</span
                        >
                        <span v-else-if="auth.activeAccount.type === 'LECTURER'"
                          >Dosen</span
                        >
                        <span v-else-if="auth.activeAccount.type === 'STUDENT'"
                          >Mahasiswa</span
                        >
                      </p>
                    </div>
                  </div>
                </div>

                <div class="has-text-right">
                  <button
                    class="button is-primary4 has-text-right"
                    @click.prevent="nextStep"
                  >
                    <span>Berikutnya</span>
                    <span class="icon"><i class="fas fa-arrow-right"></i></span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="step == 3">
            <quick-setup-profile :afterSave="nextStep"></quick-setup-profile>
          </div>

          <div v-else-if="step == 4">
            <div class="box is-boxed-3 has-text-centered">
              <p class="title is-4 has-text-dark" style="margin-bottom: 30px">
                Mengajar Dalam Kesibukan
              </p>
              <p class="subtitle is-6 has-text-dark">
                Selesaikan semua aktivitas perkuliahan Anda dari tablet atau
                Smartphone dengan tampilan yang menarik dan mudah digunakan
              </p>
              <hr />

              <carousel :perPage="1">
                <slide
                  v-for="(c, index) in data_carousel"
                  :key="index"
                  v-html="c"
                ></slide>
              </carousel>

              <br />
            </div>

            <div class="columns">
              <div class="column has-text-centered">
                <button
                  type="button"
                  class="button is-secondary is-medium"
                  @click.prevent="toHome"
                >
                  <span class="icon"><i class="fas fa-check-circle"></i></span>
                  <span>SELESAI</span>
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { USER, ONBOARD } from "~/consts";
import SuccessCheck from "~/components/SuccessCheck";
import AddUniversityAccount from "~/components/AddUniversityAccount";
import QuickSetupProfile from "~/components/QuickSetupProfile";

export default {
  components: {
    SuccessCheck,
    AddUniversityAccount,
    QuickSetupProfile,
  },

  mounted() {
    this.findCurrentStep();
    this.setupAccount = !this.isEmpty(this.auth.activeAccount) ? false : true;
  },

  computed: {
    ...mapState({
      auth: (state) => state.auth,
      account: (state) => state.auth.activeAccount,
    }),
  },
  data() {
    return {
      step: 0,
      dont_show_again: false,
      data_carousel: [
        '<div><figure class="image" style="width: 75%; margin: auto auto 25px;"><img src="https://edlink.id/img/Frame%2015.png" /></figure><p class="title has-text-dark is-5" style="font-weight: 700;">Push notifikasi dan lihat jadwal perkulihan</p><p class="subtitle has-text-dark is-6">Muncul pemberitahuan jadwal masuk Mahasiswa dan dosen sebagai pengingat aktivitas perkuliahan.</p></div>',
        '<div><figure class="image" style="width: 75%; margin: auto auto 25px;"><img src="https://edlink.id/img/Frame%2017.png" /></figure><p class="title has-text-dark is-5" style="font-weight: 700;">Lakukan pengerjaaan kuis dan tugas dengan mudah</p><p class="subtitle has-text-dark is-6">Kuiz online langsung muncul hasil ujian dan otomatis membuat peringkat kuis-kuis.</p></div>',
        '<div><figure class="image" style="width: 75%; margin: auto auto 25px;"><img src="https://edlink.id/img/Frame%2018.png" /></figure><p class="title has-text-dark is-5" style="font-weight: 700;">Format laporan yang lebih informatif</p><p class="subtitle has-text-dark is-6">Pengelompokan laporan aktivitas perkuliahan dengan tampilan yang mudah dipahami.</p></div>',
        '<div><figure class="image" style="width: 75%; margin: auto auto 25px;"><img src="https://edlink.id/img/Frame%2016.png" /></figure><p class="title has-text-dark is-5" style="font-weight: 700;">Tatap muka secara daring dan langsung absen</p><p class="subtitle has-text-dark is-6">Aktivitas perkuliahan berjalan lancar dengan adanya fitur ini.</p></div>',
      ],
      setupAccount: true,
    };
  },

  methods: {
    ...mapMutations({
      setAuth: 'setAuth'
    }),
    prevStep() {
      this.step = this.step > 0 ? this.step - 1 : 0;
    },
    nextStep() {
      if (
        this.step === 2 &&
        this.auth.email !== null &&
        this.auth.setPasswordNeeded !== true
      ) {
        this.step = 4;
        return;
      }

      this.step = this.step + 1;
    },
    findCurrentStep() {
      if (this.auth.setupOnboard === true) {
        this.step = 0;
        return;
      }

      if (this.auth.email === null || this.auth.setPasswordNeeded === true) {
        this.step = 3;
        return;
      }
    },
    async toHome() {
      const vm = this;

      if (vm.dont_show_again) {
        vm.$cookies.set(trans("dont_show_again_setup"), 1, {
          expires: moment().add(1, "week").toDate(),
          path: "/",
        });
      }

      await this.$axios.post(USER.SETUP_DONE);
      await this.$store.dispatch("getProfile");

      vm.$router.push("/panel");
    },
    toPrivacyPolicy() {
      window.open("https://www.edlink.id/privacy-policy", "_blank");
    },
    async approvePrivacyPolicy() {
      const { data } = await this.$axios.post(ONBOARD.APPROVE_PRIVACY_POLICY)

      if (data.applicationSystem.code == 0) {
        const { data } = await this.$axios.post(USER.GET_PROFILE)
        
        await this.$store.dispatch("getProfile");
        this.nextStep()
        
      } else {
        this.$buefy.toast.open({
          message: data.applicationSystem.message,
          type: "is-danger",
        });
      }
    },
  },
};
</script>

<style scoped>
.step-details {
  font-size: 13px;
}
.steps .step-item.is-active::before,
.steps .step-item.is-completed::before {
  background: #279b24;
}
.steps .step-item.is-completed .step-marker {
  background-color: #279b24;
}
.steps .step-item.is-active .step-marker {
  border-color: #279b24;
  color: #279b24;
}
</style>
